
import { GridSize, BrandColor } from './types';

export const JOISST_API_URL = 'https://api.joisst.com';
// This should be dynamic or configured based on environment in production
export const APP_URL = 'https://brandgrid.joisst.com'; 

export const DEFAULT_COLORS: BrandColor[] = [
  { id: 'c1', hex: '#f63b23', cmyk: 'C:0 M:90 Y:100 K:0', name: 'Primary Brand Color', visible: true },
  { id: 'c2', hex: '#faf084', cmyk: 'C:4 M:0 Y:60 K:0', name: 'Secondary Brand Color', visible: true },
  { id: 'c3', hex: '#ccf741', cmyk: 'C:20 M:0 Y:85 K:0', name: 'Accent Color', visible: true },
  { id: 'c4', hex: '#260602', cmyk: 'C:40 M:70 Y:70 K:90', name: 'Neutral', visible: true },
  { id: 'c5', hex: '#feeeed', cmyk: 'C:0 M:5 Y:5 K:0', name: 'Highlight Color', visible: true },
];

export const COLORS = {
  text: '#260602',
  background: '#feeeed',
  primary: '#f63b23',
  secondary: '#faf084',
  accent: '#ccf741',
};

export const PRICING = {
  wholesale: {
    basic: 10,
    ai: 20
  },
  retail: {
    basic: 24.95,
    ai: 49.95
  }
};

export const AVAILABLE_FONTS = [
  { name: 'Inter', url: 'Inter' },
  { name: 'Playfair Display', url: 'Playfair+Display' },
  { name: 'Roboto', url: 'Roboto' },
  { name: 'Oswald', url: 'Oswald' },
  { name: 'Merriweather', url: 'Merriweather' },
  { name: 'Space Mono', url: 'Space+Mono' }
];

export const GRID_MAPPING: Record<GridSize, string> = {
  [GridSize.SQUARE_SM]: 'col-span-1 row-span-1 aspect-square',
  [GridSize.SQUARE_MD]: 'col-span-2 row-span-2 aspect-square',
  [GridSize.SQUARE_LG]: 'col-span-4 row-span-4 aspect-square',
  // Updated to 2/1 to match 4:2 box request
  [GridSize.LANDSCAPE_SM]: 'col-span-2 row-span-1 aspect-[2/1]',
  [GridSize.LANDSCAPE_MD]: 'col-span-4 row-span-2 aspect-[2/1]',
  [GridSize.PORTRAIT_SM]: 'col-span-1 row-span-2 aspect-[9/16]',
  [GridSize.PORTRAIT_MD]: 'col-span-2 row-span-4 aspect-[9/16]',
};

// Mock Data
export const MOCK_USER_ID = 'user-123';
export const MOCK_AGENCY_ID = 'agency-999';
